function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.469 35.951c0-1.965-1.264-3.559-3.18-3.559-.957 0-2.111 1.046-2.738 1.689-.627-.644-1.705-1.691-2.662-1.691-1.914 0-3.256 1.594-3.256 3.56 0 .983.387 1.874 1.016 2.517l4.906 4.907 4.902-4.9-.006-.003a3.6 3.6 0 001.018-2.52"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.676 28.928a.807.807 0 001.453-.698L47.7 19.071a.808.808 0 00-1.498.118L37.79 47.076l-2.308-13.417a.807.807 0 00-1.504-.246l-3.724 6.889-1.652-11.528a.804.804 0 00-1.533-.213l-3.858 8.647H12.337a.803.803 0 100 1.608h11.398a.807.807 0 00.736-.478l2.932-6.573 1.604 11.182a.805.805 0 001.506.268l3.776-6.988 2.494 14.488a.801.801 0 00.793.668c.354 0 .668-.23.77-.572l8.804-29.178 3.526 7.295z"
}));

var SvgOds03 = function SvgOds03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOds03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ods03.40b61cc0.svg";
export { ForwardRef as ReactComponent };